import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=37ac82ea&scoped=true"
import script from "./ratings.vue?vue&type=script&lang=ts"
export * from "./ratings.vue?vue&type=script&lang=ts"
import style0 from "./ratings.vue?vue&type=style&index=0&id=37ac82ea&lang=scss"
import style1 from "./ratings.vue?vue&type=style&index=1&id=37ac82ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac82ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ac82ea')) {
      api.createRecord('37ac82ea', component.options)
    } else {
      api.reload('37ac82ea', component.options)
    }
    module.hot.accept("./ratings.vue?vue&type=template&id=37ac82ea&scoped=true", function () {
      api.rerender('37ac82ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/ratings.vue"
export default component.exports